import { cloneDeep } from 'lodash';

export const stringToHash = (value) => {
    var hash = 0, i, chr;
    if (value.length === 0) return hash;
    for (i = 0; i < value.length; i++) {
        chr = value.charCodeAt(i);
        hash = ((hash << 5) - hash) + chr;
        hash |= 0; // Convert to 32bit integer
    }
    return hash;
}

export const addArrayItem = (array, newItem) => {
    const newArray = cloneDeep(array ? array : []).concat([newItem]);
    return newArray;
}

export const updateArrayItem = (array, updatedItem, selector) => {
    const newArray = cloneDeep(array ? array : []);
    if (newArray && newArray.length > 0) {
        const index = newArray.findIndex(selector);
        if (index !== -1)
            newArray[index] = updatedItem;
    }
    return newArray;
}

export const removeArrayItem = (array, selector) => {
    const newArray = cloneDeep(array ? array : []).filter((x) => !selector(x));
    return newArray;
}

export const removeObjectArrayItem = (obj, getter, selector) => {
    const newObj = cloneDeep(obj);
    const newArray = (getter(newObj) || []);
    const index = newArray.findIndex((x) => selector(x));
    if (index !== -1)
        newArray.splice(index, 1);
    return newObj;
}

export const addBundleItem = (bundle, newItem) => {
    const newBundle = cloneDeep(bundle);
    newBundle.items = (newBundle.items ? newBundle.items : []).concat([newItem]);
    return newBundle;
}

export const updateBundleItem = (bundle, updatedItem, selector) => {
    const newBundle = cloneDeep(bundle);
    if (newBundle.items && newBundle.items.length > 0) {
        const index = newBundle.items.findIndex(selector);
        if (index !== -1)
            newBundle.items[index] = updatedItem;
    }
    return newBundle;
}

export const removeBundleItem = (bundle, selector) => {
    const newBundle = cloneDeep(bundle);
    if (newBundle.items && newBundle.items.length > 0) {
        newBundle.items = newBundle.filter((x) => !selector(x));
    }
    return newBundle;
}